<template>
  <footer class="section-footer">
    <v-container>
      <v-row class="footer-main-row">
        <v-col :cols="device.desktop ? `5` : `12`">
          <div class="footer-brand-card">
            <div class="footer-title">{{ info.app_company }}</div>
            <div class="footer-subtitle">Layanan Monitoring CCTV Kabupaten Tangerang</div>
            <div class="address">{{ info.app_address }}</div>
          </div>
        </v-col>

        <v-col :cols="device.desktop ? `4` : `12`">
          <div class="footer-card">
            <div class="footer-section-title">Kontak</div>
            <div class="footer-item">
              <v-icon
                small
                color="blue lighten-2"
              >mdi-phone</v-icon>
              <span>{{ info.app_wa }}</span>
            </div>
          </div>
        </v-col>

        <v-col :cols="device.desktop ? `3` : `12`">
          <div class="footer-card">
            <div class="footer-section-title">Sosial Media</div>
            <div class="footer-item">
              <v-icon
                small
                color="blue lighten-2"
              >mdi-facebook</v-icon>
              <span>Facebook</span>
            </div>
            <div class="footer-item">
              <v-icon
                small
                color="pink lighten-2"
              >mdi-instagram</v-icon>
              <span>Instagram</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <div class="footer-bottom">
      <v-container>
        <div class="copyright">
          Copyright &copy; 2022 - 2026 {{ info.app_company }}. All rights reserved.
        </div>
      </v-container>
    </div>
  </footer>

</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "FooterComponent",
  data: () => ({}),
  mounted() {},
  computed: {
    ...mapState(["device", "theme", "info"]),
  },
  methods: {},
  watch: {},
};
</script>

<style scoped>
.section-footer {
  background: linear-gradient(135deg, #0f172a 0%, #0b3a79 60%, #1e3a8a 100%);
  color: #ffffff;
  padding-top: 30px;
  margin-top: 32px;
}

.footer-main-row {
  padding-bottom: 20px;
}

.footer-brand-card,
.footer-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(191, 219, 254, 0.35);
  border-radius: 14px;
  padding: 16px 18px;
  height: 100%;
  backdrop-filter: blur(2px);
}

.footer-title {
  font-size: 21px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.3;
}

.footer-subtitle {
  font-size: 12px;
  color: #bfdbfe;
  margin-top: 4px;
  margin-bottom: 10px;
}

.address {
  font-size: 13px;
  line-height: 1.6;
  color: #e2e8f0;
}

.footer-section-title {
  margin-bottom: 10px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
}

.footer-item {
  font-size: 14px;
  color: #e2e8f0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
}

.footer-bottom {
  background: rgba(2, 6, 23, 0.45);
  border-top: 1px solid rgba(148, 163, 184, 0.25);
}

.copyright {
  font-size: 12px;
  color: #cbd5e1;
  text-align: center;
  padding: 12px 0;
}

@media (max-width: 960px) {
  .section-footer {
    padding-top: 20px;
  }

  .footer-brand-card,
  .footer-card {
    height: auto;
  }

  .footer-title {
    font-size: 19px;
  }
}
</style>